module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAPCAYAAAD+pA/bAAAAAXNSR0IArs4c6QAAAIBJREFUOBFjZEAAPSBTBcGliPUJqHsfEP+DmZIIZPynMp4AMpwJRACBGoSiKimGbJoEkHMHiKnli1dAszSQLQCxZYGYGpaADNcFGYgNUGoJXsNhFpJrCVGGk2sJSYaTaglZhhNrCUWGE7KEKobjsoSqhiNbsg7I2QXEOjDB4U8DAHDYhfqS8OE3AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jt6.png
// module id = AQD/
// module chunks = 1